import PDFViewer from "@common/components/PDFViewer"

export default function InfoDevelopment(props: any) {
  const { pdfFile } = props

  return <PDFViewer pdfFile={pdfFile} pageDisplay="single" />
}
